import { render, staticRenderFns } from "./LayoutTools.vue?vue&type=template&id=07ac1b5c&scoped=true&"
import script from "./LayoutTools.vue?vue&type=script&lang=ts&"
export * from "./LayoutTools.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutTools.vue?vue&type=style&index=0&id=07ac1b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac1b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
